/* ============================================================
   LIV-OUTDOORS GLOBAL CART AJAX
   Asset: assets/lo-cart-ajax.js
   
   Loads on EVERY page via theme.liquid.
   Patches the nav's cart drawer to use AJAX for:
   - Quantity changes (no page refresh)
   - Remove items (no page refresh)
   - Opening drawer always fetches fresh cart data
   
   NOTE: lo-product.js handles add-to-cart on product pages.
   This file handles everything else site-wide.
   ============================================================ */

(function() {
  'use strict';

  // ── Inject cart item styles globally ──
  var style = document.createElement('style');
  style.textContent = '' +
    '.lo-cart-item-row { display:flex !important; align-items:center !important; justify-content:space-between !important; margin-top:8px; }' +
    '.lo-cart-item-qty { display:flex !important; align-items:center !important; border:1px solid rgba(128,129,133,.2); border-radius:4px; overflow:hidden; }' +
    '.lo-cart-qty-btn { width:28px !important; height:28px !important; display:flex !important; align-items:center !important; justify-content:center !important; background:none !important; border:none !important; cursor:pointer; font-family:Jost,sans-serif; font-size:14px; color:#0A1518; }' +
    '.lo-cart-qty-btn:hover { background:rgba(117,151,160,.08) !important; }' +
    '.lo-cart-qty-val { width:28px !important; text-align:center !important; font-family:Jost,sans-serif; font-size:13px; font-weight:600; border-left:1px solid rgba(128,129,133,.15); border-right:1px solid rgba(128,129,133,.15); }' +
    '.lo-cart-item-price { font-family:Jost,sans-serif; font-size:15px; font-weight:700; color:#0A1518; }' +
    '.lo-cart-shipping { display:none !important; }' +
    '.lo-cart-footer { display:none !important; }' +
    '#lo-cart-drawer { visibility:hidden; box-shadow:none; }' +
    '#lo-cart-drawer.lo-open { visibility:visible; box-shadow:-8px 0 20px rgba(0,0,0,.08); }';
  document.head.appendChild(style);

  var cartDrawer = document.getElementById('lo-cart-drawer');
  if (!cartDrawer) return;

  var cartOverlay = document.getElementById('lo-cart-overlay');

  // ── Find the items container inside the nav's drawer ──
  function getContainer() {
    return cartDrawer.querySelector('.lo-cart-items') ||
           cartDrawer.querySelector('.lo-cart-body') ||
           null;
  }

  // ── Render cart items (groups add-ons under main products) ──
  function loRenderCart(cart) {
    // Update all cart count badges
    document.querySelectorAll('[data-lo-cart-count], .lo-cart-count-badge, #lo-cart-count').forEach(function(el) {
      el.textContent = cart.item_count;
      if (el.style) el.style.display = cart.item_count > 0 ? '' : 'none';
    });

    var container = getContainer();
    if (!container) return;

    if (cart.items.length === 0) {
      container.innerHTML = '<p style="text-align:center;color:#808185;padding:40px 0;font-family:Jost,sans-serif;font-size:14px;">Your cart is empty</p>';
      var footer = cartDrawer.querySelector('.lo-cart-footer');
      if (footer) footer.style.display = 'none';
      return;
    }

    // Separate main items and add-ons
    var mainItems = [];
    var addons = [];
    cart.items.forEach(function(item, index) {
      item._lineIndex = index + 1;
      var props = item.properties || {};
      if (props._addon_for) {
        addons.push(item);
      } else {
        mainItems.push(item);
      }
    });

    var html = '';

    mainItems.forEach(function(item) {
      var img = item.image || '';
      if (img) img = img.replace(/(\.\w+)(\?|$)/, '_180x$1$2');

      // Find add-ons that belong to this product
      var myAddons = addons.filter(function(a) {
        return (a.properties._addon_for || '').toLowerCase() === item.product_title.toLowerCase();
      });

      // Calculate build total
      var buildTotal = item.final_line_price;
      myAddons.forEach(function(a) { buildTotal += a.final_line_price; });
      var hasAddons = myAddons.length > 0;

      // Main item
      html += '<div class="lo-cart-group" style="padding:16px 0;border-bottom:1px solid rgba(128,129,133,.12);">';
      html += '<div class="lo-cart-item" data-line="' + item._lineIndex + '" data-key="' + item.key + '" style="display:flex;gap:14px;">' +
        (img ? '<img class="lo-cart-item-img" src="' + img + '" alt="' + item.title + '" style="width:80px;height:80px;object-fit:cover;border-radius:4px;flex-shrink:0;" />' : '') +
        '<div class="lo-cart-item-info" style="flex:1;min-width:0;">' +
          '<p class="lo-cart-item-brand" style="font-size:10px;font-weight:600;letter-spacing:1.5px;text-transform:uppercase;color:#7597A0;margin:0 0 2px;">' + (item.vendor || '') + '</p>' +
          '<p class="lo-cart-item-name" style="font-size:14px;font-weight:600;color:#0A1518;margin:0 0 2px;line-height:1.3;">' + item.product_title + '</p>' +
          (item.variant_title ? '<p class="lo-cart-item-variant" style="font-size:12px;color:#808185;margin:0 0 2px;">' + item.variant_title + '</p>' : '') +
          '<div class="lo-cart-item-row" style="display:flex;align-items:center;justify-content:space-between;margin-top:8px;">' +
            '<div class="lo-cart-item-qty" style="display:flex;align-items:center;border:1px solid rgba(128,129,133,.2);border-radius:4px;overflow:hidden;">' +
              '<button class="lo-cart-qty-btn" data-key="' + item.key + '" data-delta="-1" type="button" style="width:28px;height:28px;display:flex;align-items:center;justify-content:center;background:none;border:none;cursor:pointer;font-size:14px;">−</button>' +
              '<span class="lo-cart-qty-val" style="width:28px;text-align:center;font-size:13px;font-weight:600;border-left:1px solid rgba(128,129,133,.15);border-right:1px solid rgba(128,129,133,.15);">' + item.quantity + '</span>' +
              '<button class="lo-cart-qty-btn" data-key="' + item.key + '" data-delta="1" type="button" style="width:28px;height:28px;display:flex;align-items:center;justify-content:center;background:none;border:none;cursor:pointer;font-size:14px;">+</button>' +
            '</div>' +
            '<span class="lo-cart-item-price" style="font-size:15px;font-weight:700;color:#0A1518;">$' + (item.final_line_price / 100).toFixed(2) + '</span>' +
          '</div>' +
          '<button class="lo-cart-item-remove" data-key="' + item.key + '" type="button" style="font-family:Jost,sans-serif;font-size:11px;font-weight:500;letter-spacing:.5px;text-transform:uppercase;color:#808185;background:none;border:none;cursor:pointer;padding:4px 0;margin-top:4px;">Remove</button>' +
        '</div>' +
      '</div>';

      // Add-ons nested under main item
      if (hasAddons) {
        myAddons.forEach(function(addon) {
          html += '<div class="lo-cart-addon" data-line="' + addon._lineIndex + '" data-key="' + addon.key + '" style="display:flex;align-items:center;justify-content:space-between;margin:8px 0 0 28px;padding:8px 12px 8px 12px;background:rgba(117,151,160,.04);border-radius:4px;border-left:2px solid #7597A0;">' +
            '<div style="display:flex;align-items:center;gap:8px;">' +
              '<span style="font-family:Jost,sans-serif;font-size:12px;color:#808185;">└</span>' +
              '<span style="font-family:Jost,sans-serif;font-size:13px;font-weight:500;color:#0A1518;">' + addon.product_title + '</span>' +
            '</div>' +
            '<div style="display:flex;align-items:center;gap:12px;">' +
              '<span style="font-family:Jost,sans-serif;font-size:13px;font-weight:600;color:#0A1518;">$' + (addon.final_line_price / 100).toFixed(2) + '</span>' +
              '<button class="lo-cart-item-remove" data-key="' + addon.key + '" type="button" style="font-family:Jost,sans-serif;font-size:10px;font-weight:500;color:#808185;background:none;border:none;cursor:pointer;text-transform:uppercase;letter-spacing:.5px;">✕</button>' +
            '</div>' +
          '</div>';
        });

        // Build total line
        html += '<div style="display:flex;justify-content:space-between;align-items:center;margin:10px 0 0 28px;padding:8px 24px 0 0;border-top:1px dashed rgba(128,129,133,.15);">' +
          '<span style="font-family:Jost,sans-serif;font-size:12px;font-weight:600;letter-spacing:.5px;text-transform:uppercase;color:#7597A0;">Build Total</span>' +
          '<span style="font-family:Jost,sans-serif;font-size:15px;font-weight:700;color:#0A1518;">$' + (buildTotal / 100).toFixed(2) + '</span>' +
        '</div>';
      }

      html += '</div>'; // close lo-cart-group
    });

    // Any orphan add-ons (parent was removed) — show as regular items
    var claimedAddons = [];
    mainItems.forEach(function(item) {
      addons.forEach(function(a) {
        if ((a.properties._addon_for || '').toLowerCase() === item.product_title.toLowerCase()) {
          claimedAddons.push(a.key);
        }
      });
    });
    addons.forEach(function(addon) {
      if (claimedAddons.indexOf(addon.key) === -1) {
        var img = addon.image || '';
        if (img) img = img.replace(/(\.\w+)(\?|$)/, '_180x$1$2');
        html += '<div class="lo-cart-group" style="padding:16px 0;border-bottom:1px solid rgba(128,129,133,.12);">';
        html += '<div class="lo-cart-item" data-line="' + addon._lineIndex + '" data-key="' + addon.key + '" style="display:flex;gap:14px;">' +
          (img ? '<img class="lo-cart-item-img" src="' + img + '" style="width:80px;height:80px;object-fit:cover;border-radius:4px;flex-shrink:0;" />' : '') +
          '<div class="lo-cart-item-info" style="flex:1;">' +
            '<p style="font-size:14px;font-weight:600;color:#0A1518;margin:0 0 4px;">' + addon.product_title + '</p>' +
            '<div class="lo-cart-item-row" style="display:flex;align-items:center;justify-content:space-between;margin-top:8px;">' +
              '<div class="lo-cart-item-qty" style="display:flex;align-items:center;border:1px solid rgba(128,129,133,.2);border-radius:4px;overflow:hidden;">' +
                '<button class="lo-cart-qty-btn" data-key="' + addon.key + '" data-delta="-1" type="button" style="width:28px;height:28px;display:flex;align-items:center;justify-content:center;background:none;border:none;cursor:pointer;font-size:14px;">−</button>' +
                '<span class="lo-cart-qty-val" style="width:28px;text-align:center;font-size:13px;font-weight:600;border-left:1px solid rgba(128,129,133,.15);border-right:1px solid rgba(128,129,133,.15);">' + addon.quantity + '</span>' +
                '<button class="lo-cart-qty-btn" data-key="' + addon.key + '" data-delta="1" type="button" style="width:28px;height:28px;display:flex;align-items:center;justify-content:center;background:none;border:none;cursor:pointer;font-size:14px;">+</button>' +
              '</div>' +
              '<span style="font-size:15px;font-weight:700;color:#0A1518;">$' + (addon.final_line_price / 100).toFixed(2) + '</span>' +
            '</div>' +
            '<button class="lo-cart-item-remove" data-key="' + addon.key + '" type="button" style="font-family:Jost,sans-serif;font-size:11px;font-weight:500;letter-spacing:.5px;text-transform:uppercase;color:#808185;background:none;border:none;cursor:pointer;padding:4px 0;margin-top:4px;">Remove</button>' +
          '</div>' +
        '</div>';
        html += '</div>';
      }
    });

    container.innerHTML = html;

    // Build or update footer with subtotal + checkout + continue
    var footer = cartDrawer.querySelector('.lo-cart-footer-dynamic');
    if (!footer) {
      footer = document.createElement('div');
      footer.className = 'lo-cart-footer-dynamic';
      footer.style.cssText = 'padding:20px 24px;border-top:1px solid rgba(128,129,133,.12);';
      // Insert after the container (body)
      var body = cartDrawer.querySelector('.lo-cart-body');
      if (body) {
        body.parentNode.insertBefore(footer, body.nextSibling);
      } else {
        cartDrawer.appendChild(footer);
      }
    }

    if (cart.items.length > 0) {
      footer.style.display = '';
      footer.innerHTML = '' +
        '<div style="display:flex;justify-content:space-between;align-items:center;margin-bottom:6px;">' +
          '<span style="font-family:Jost,sans-serif;font-size:12px;font-weight:600;letter-spacing:1px;text-transform:uppercase;color:#808185;">Subtotal</span>' +
          '<span style="font-family:Jost,sans-serif;font-size:20px;font-weight:700;color:#0A1518;">$' + (cart.total_price / 100).toFixed(2) + '</span>' +
        '</div>' +
        '<p style="font-family:Jost,sans-serif;font-size:11px;color:#808185;margin:0 0 16px;">Shipping &amp; taxes calculated at checkout</p>' +
        '<a href="/checkout" style="display:block;width:100%;padding:14px;font-family:Jost,sans-serif;font-size:14px;font-weight:700;letter-spacing:1px;text-transform:uppercase;text-align:center;text-decoration:none;background:#0A1518;color:#fff;border-radius:4px;box-sizing:border-box;">Checkout</a>' +
        '<button id="lo-cart-continue-dynamic" type="button" style="display:block;width:100%;padding:10px;font-family:Jost,sans-serif;font-size:12px;font-weight:500;letter-spacing:.5px;text-transform:uppercase;text-align:center;color:#808185;background:none;border:none;cursor:pointer;margin-top:8px;">Continue Shopping</button>';
      
      // Bind continue shopping to close drawer
      var continueBtn = footer.querySelector('#lo-cart-continue-dynamic');
      if (continueBtn) {
        continueBtn.addEventListener('click', function() {
          cartDrawer.classList.remove('lo-open');
          if (cartOverlay) cartOverlay.classList.remove('open', 'lo-open');
          document.body.style.overflow = '';
        });
      }
    } else {
      footer.style.display = 'none';
    }

    // Bind quantity buttons
    container.querySelectorAll('.lo-cart-qty-btn').forEach(function(btn) {
      btn.addEventListener('click', function(e) {
        e.preventDefault();
        e.stopPropagation();
        var key = btn.dataset.key;
        var delta = parseInt(btn.dataset.delta);
        var qtyEl = btn.parentElement.querySelector('.lo-cart-qty-val');
        var newQty = parseInt(qtyEl.textContent) + delta;
        if (newQty < 0) newQty = 0;
        loAjaxCartUpdate(key, newQty);
      });
    });

    // Bind remove buttons
    container.querySelectorAll('.lo-cart-item-remove').forEach(function(btn) {
      btn.addEventListener('click', function(e) {
        e.preventDefault();
        e.stopPropagation();
        loAjaxCartUpdate(btn.dataset.key, 0);
      });
    });
  }

  // ── AJAX cart update ──
  function loAjaxCartUpdate(key, qty) {
    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: key, quantity: qty })
    })
    .then(function(r) { return r.json(); })
    .then(function(cart) {
      loRenderCart(cart);
    });
  }

  // ── Refresh and open cart ──
  function loRefreshAndOpenCart() {
    fetch('/cart.js')
      .then(function(r) { return r.json(); })
      .then(function(cart) {
        loRenderCart(cart);
        if (cartDrawer) cartDrawer.classList.add('lo-open');
        if (cartOverlay) cartOverlay.classList.add('open');
        document.body.style.overflow = 'hidden';
      });
  }

  // Expose globally
  window.loRenderCart = loRenderCart;
  window.loRefreshAndOpenCart = loRefreshAndOpenCart;
  window.loAjaxCartUpdate = loAjaxCartUpdate;

  // ── Override nav's loCartQty to prevent page refresh ──
  window.loCartQty = function(line, qty) {
    var item = cartDrawer.querySelector('[data-line="' + line + '"]');
    if (item && item.dataset.key) {
      loAjaxCartUpdate(item.dataset.key, qty);
    } else {
      fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ line: line, quantity: qty })
      })
      .then(function(r) { return r.json(); })
      .then(function(cart) { loRenderCart(cart); });
    }
  };

  // ── Patch the nav's openCart to always refresh first ──
  var originalOpenCart = window.openCart;
  window.openCart = function() {
    loRefreshAndOpenCart();
  };

  // Also patch the cart button click to use our refreshing version
  var cartBtn = document.getElementById('lo-cart-btn');
  if (cartBtn) {
    // Remove old listeners by cloning
    var newCartBtn = cartBtn.cloneNode(true);
    cartBtn.parentNode.replaceChild(newCartBtn, cartBtn);
    newCartBtn.addEventListener('click', function(e) {
      e.preventDefault();
      e.stopPropagation();
      loRefreshAndOpenCart();
    });
  }

  // ── On page load, refresh cart data so drawer is ready ──
  fetch('/cart.js')
    .then(function(r) { return r.json(); })
    .then(function(cart) {
      loRenderCart(cart);
    });

})();